import { render, staticRenderFns } from "./HoraNueva.vue?vue&type=template&id=89f963d6&scoped=true&"
import script from "./HoraNueva.vue?vue&type=script&lang=js&"
export * from "./HoraNueva.vue?vue&type=script&lang=js&"
import style0 from "./HoraNueva.vue?vue&type=style&index=0&id=89f963d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f963d6",
  null
  
)

export default component.exports